<template>
  <div class="min-h-screen px-5 py-3">
    <div class="my-3">
      <c-button class="btn-dark-rounded" @click="showSheet">Show Bottom Sheet</c-button>
      <bottom-sheet name="sample_sheet" ref="sample_sheet">
        <div>
          <div class="text-xl">BottomSheet sample</div>
        </div>
      </bottom-sheet>
    </div>
    <div class="my-3">
      <c-button class="btn-dark-rounded" @click="showModal">Show Modal</c-button>
      <dialog-modal name="sample_modal" ref="sample_modal">
        <div>
          <div class="text-xl">Modal sample</div>
        </div>
      </dialog-modal>
    </div>
    <div class="mx-3">
      <card>
        <div class="flex flex-col">
          <div class="py-2 text-lg font-bold text-left px-2">Sample Card</div>
          <div
            class="flex-1 py-2 text-left px-2"
          >The content of the card can to be anything. The card will grow to it.</div>
          <div class="h-12 flex rounded-b-lg">
            <div class="flex-1 bg-red-400 text-white flex flex-col justify-center">Deny</div>
            <div class="flex-1 bg-green-400 text-white flex flex-col justify-center">Accept</div>
          </div>
        </div>
      </card>
    </div>
    <div class="my-4 flex flex-wrap mx-auto">
      <c-button>Default Button</c-button>
      <c-button class="btn-dark-rounded">Button Rounded</c-button>
      <c-button class="btn-dark-rounded-full">Button Rounded Full</c-button>
      <c-button class="bg-green-500 text-white">Button Color</c-button>
    </div>
    <div v-if="haveLocation">
      <map-embed :lat="location.coords.latitude" :long="location.coords.longitude"></map-embed>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import BottomSheet from "@/components/common/BottomSheet.vue";
import DialogModal from "@/components/common/DialogModal.vue";
import Card from "@/components/common/Card.vue";
import CButton from "@/components/common/CButton.vue";
import MapEmbed from "@/components/common/MapEmbed.vue";

export default Vue.extend({
  name: "Samples",
  components: {
    BottomSheet,
    DialogModal,
    Card,
    CButton,
    MapEmbed
  },
  data() {
    return {
      haveLocation: false,
      location: null
    };
  },
  methods: {
    showSheet() {
      this.$refs.sample_sheet.showSheet();
    },
    showModal() {
      this.$refs.sample_modal.showModal();
    },
    updateLocation(position) {
      if (location) {
        this.location = position;
        this.haveLocation = true;
      }
    }
  },
  mounted() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(this.updateLocation);
    }
  }
});
</script>
